import { Answer } from './answer.model';
import { Question } from './question.model';
import { BaseEntity, ID } from '@ianesthesie-kit/services';

export enum QuestionnaireStatus {
  NOT_STARTED = 'NOT_STARTED',
  IN_PROGRESS = 'IN_PROGRESS',
  COMPLETED = 'COMPLETED',
  CANCELED = 'CANCELED'
}

export const isPendingStatus = (
  st?: QuestionnaireStatus
): st is QuestionnaireStatus.IN_PROGRESS | QuestionnaireStatus.NOT_STARTED =>
  st === QuestionnaireStatus.IN_PROGRESS ||
  st === QuestionnaireStatus.NOT_STARTED;

export interface QuestionnaireQuestionResponse {
  id: ID;
  pediatric?: boolean;
  questionnaireCode: string;
  answers?: Record<ID, Answer>;
  questions?: Question[];
  orderIndex: number;
  totalQuestions: number;
  questionnaireStatus: QuestionnaireStatus;
  groupName?: string;
  groupTitleId?: string;
}

export interface QuestionnaireStatusResponse {
  questionnaireStatus?: QuestionnaireStatus;
}

export interface AssignedQuestionnaire extends BaseEntity {
  status: QuestionnaireStatus;
  hospitalQuestionnaireId: ID;
  patientId: ID;
  surgicalEventId: ID;
  questionnaireCode: string;
  completedAt?: string;
  type: string;
}

export interface HospitalQuestionnaireDto extends BaseEntity {
  code: string;
  enabled: boolean;
  defaultQuestionnaire: boolean;
  multipleAssignmentsAllowed: boolean;
}
